import React from "react"
import Container from "../common/Container"
import ItalicHeading from "../components/ui/ItalicHeading"
import PolicyText from "../common/PolicyText"
import DynamicNavigation from "../components/ui/DynamicNavigation"
import Layout from "../components/Layout"
import styled from "styled-components"
import SEO from "../components/SEO"
import { convertPrismicToAbleJumpLink, toPage } from "../lib/utils"
import { graphql } from "gatsby"

const Wrapper = styled.div`
  padding: 40px 0;
`

export default function CommunicationPreferencesDetailPage({ data }) {
  const page = toPage(data)
  const newContent = convertPrismicToAbleJumpLink(page.contents)

  return (
    <Layout>
      <SEO
        title="Cerebral Communication Preferences Detail"
        titleSuffix="Cerebral's Communication Preferences Detail enables a better care plan"
        description="Learn about Cerebral's Communication Preferences Detail and how your information may be used to better inform your care plan."
      />
      <DynamicNavigation />
      <Wrapper>
        <Container>
          <ItalicHeading>{page.title}</ItalicHeading>
          <PolicyText dangerouslySetInnerHTML={{ __html: newContent }} />
        </Container>
      </Wrapper>
    </Layout>
  )
}

export const query = graphql`
  query CommunicationPreferencesDetailPageQuery($lang: String) {
    page: allPrismicCommunicationPreferencesDetail(
      filter: { lang: { eq: $lang } }
    ) {
      edges {
        node {
          data {
            contents {
              html
            }
            title {
              text
            }
          }
        }
      }
    }
  }
`
